module.exports = __webpack_public_path__ + "images/save-view-as-061fff65.svg";